import http from "../utils/axiosInstance";

class usersDataService {
  fetchAll(page, limit) {
    return http.get(`/users?page=${page}&limit=${limit}`);
  }
  fetchById(id) {
    return http.get(`/users/${id}`);
  }
  isActive(id) {
    return http.post(`/users/${id}/active`);
  }
  deleteUser(id) {
    return http.delete(`/users/${id}`);
  }
  update(id, data) {
    return http.put(`/users/${id}`, data);
  }
  getUserWithTasks(id) {
    return http.get(`/users/alluser/tasks`);
  }
  forgetPassword(data) {
    return http.post(`/users/forgot-password`, data);
  }
  getCurrentAuthUser() {
    return localStorage.getItem("currentUser");
  }
  resetPassword(data, token) {
    return http.post(`/users/reset-password`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }
  resetFromEmail(token, data) {
    return http.post(`/users/${token}`, data);
  }
  createUserTrainingAccount(id, data) {
    return http.post(`training/${id}`, data);
  }
  changeUserBalance(id, data) {
    return http.patch(`users/${id}`, data);
  }
  getAllWhatsapps() {
    return http.get(`/media/whatsapp`);
  }
  deleteWhatsapps(id) {
    return http.delete(`/media/whatsapp/${id}`);
  }
  deleteTelegram(id) {
    return http.delete(`/media/telegram/${id}`);
  }
  getAllTelegram() {
    return http.get(`/media/telegram`);
  }
  addContacts(data, token) {
    return http.post(`/media/whatsapp`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }
  addTelegram(data, token) {
    return http.post(`/media/telegram`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }
}
const usersService = new usersDataService();
export default usersService;
